import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { CoachingEventType } from '../../coaching-base/general';
import { TranslationKeyMap } from '../../coaching-insight/coaching-insight.i18n';
import { EventTooltipData } from '../../coaching-insight/line-area.component';

@Component({
    selector: 'cmps-coaching-event-box',
    template: ` <div class="cmps-coaching-event-box--content">
        <div class="cmps-coaching-event-box--wrapper">
            <div
                class="cmps-coaching-event-box--nav-button cmps-coaching-event-box--nav-button-left"
            >
                <ng-container *ngIf="events?.length > 1">
                    <span class="cmps-coaching-event-box--nav-button-bg"></span>
                    <button
                        [disabled]="!_canGoBack"
                        (click)="_onPrevClick()"
                    >
                        <cmps-icon svgIcon="play"></cmps-icon>
                    </button>
                </ng-container>
            </div>
            <div class="cmps-coaching-event-box--name">
                <strong>{{ _event?.performer }}</strong>
                <div class="cmps-coaching-event-box--type-wrapper">
                    <div class="cmps-coaching-event-box--type">
                        <cmps-icon [svgIcon]="_icon"></cmps-icon>
                        <span>{{ _event?.eventTypeName | translate }}</span>
                    </div>
                </div>
            </div>
            <div class="cmps-coaching-event-box--info">
                <div>
                    {{ _i18n._9783_DATE_ | translate }}
                    {{ _event?.date | date: 'LLL-d-yyyy' }}
                </div>
                <div>
                    {{ _i18n._9420_STATUS_ | translate }}
                    {{ _event?.commitmentStatusName | translate }}
                </div>
                <div>
                    {{ _i18n._9481_START_TIME_ | translate }}
                    {{ _event?.startTime | date: 'h:mm a' }}
                </div>
                <div>
                    {{ _i18n._9482_FINISH_TIME_ | translate }}
                    {{ _event?.endTime | date: 'h:mm a' }}
                </div>
            </div>
            <div class="cmps-coaching-event-box--nav-button">
                <ng-container *ngIf="events?.length > 1">
                    <span class="cmps-coaching-event-box--nav-button-bg"></span>
                    <button
                        [disabled]="!_canGoForward"
                        (click)="_onNextClick()"
                    >
                        <cmps-icon svgIcon="play"></cmps-icon>
                    </button>
                </ng-container>
            </div>
        </div>
        <ng-container *ngIf="_showGoals">
            <div class="cmps-coaching-event-box--separator"></div>
            <div
                class="cmps-coaching-event-box--goals"
                *ngIf="_event?.goals"
            >
                <cmps-scrollbar>
                    <div
                        class="cmps-coaching-event-box--goal"
                        *ngFor="let i of _event?.goals; let ii = index"
                    >
                        <!--use translate args after textId is assigned so that the colon can be part of the translate text-->
                        <div>
                            {{ _i18n._9483__METRIC_GOAL | translate }}
                            {{ ii + 1 }}: {{ i?.metricName }}
                        </div>
                        <div>
                            {{ _i18n._9484___TO_GOAL_ | translate }}
                            {{
                                i?.percentToGoal == null
                                    ? '-'
                                    : (i?.percentToGoal | percent: '1.2-2')
                            }}
                        </div>
                        <div>
                            {{ _i18n._9485___TO_TARGET_ | translate }}
                            {{
                                i?.percentToTarget == null
                                    ? '-'
                                    : (i?.percentToTarget | percent: '1.2-2')
                            }}
                        </div>
                    </div>
                </cmps-scrollbar>
            </div>
        </ng-container>
    </div>`,
    host: {
        class: 'cmps-coaching-event-box',
    },
})
export class EventBoxComponent implements OnChanges {
    /** @private */ _i18n = TranslationKeyMap;
    @Input() events: EventTooltipData[];
    /** @private */ _index: number;
    /** @private */ _canGoBack: boolean;
    /** @private */ _canGoForward: boolean;
    /** @private */ _event: EventTooltipData;
    /** @private */ _icon: string;
    /** @private */ _showGoals: boolean;

    ngOnChanges(changes: SimpleChanges): void {
        // eslint-disable-next-line no-prototype-builtins
        if (changes.hasOwnProperty('events')) {
            this._goTo(0);
        }
    }

    /** @private */ _onPrevClick(): void {
        this._goTo(this._index - 1);
    }

    /** @private */ _onNextClick(): void {
        this._goTo(this._index + 1);
    }

    private _goTo(index: number): void {
        this._index = null;
        this._canGoBack = false;
        this._canGoForward = false;
        this._event = null;
        this._icon = null;
        this._showGoals = false;

        if (!this.events || !this.events.length) {
            return;
        }

        this._index = Math.max(0, Math.min(index, this.events.length - 1));
        this._canGoBack = this._index > 0;
        this._canGoForward = this._index < this.events.length - 1;
        this._event = this.events[this._index];

        if (
            this._event.eventTypeId === CoachingEventType.COMMITMENT ||
            this._event.eventTypeId === CoachingEventType.COMMITMENT_UPDATE
        ) {
            this._icon = 'folder-account';
        }
        if (this._event.eventTypeId === CoachingEventType.OBSERVATION) {
            this._icon = 'loupe';
        }

        this._showGoals =
            this._event.eventTypeId === CoachingEventType.COMMITMENT ||
            this._event.eventTypeId === CoachingEventType.COMMITMENT_UPDATE;
    }
}
